import { render, staticRenderFns } from "./MedicalInfoForm.vue?vue&type=template&id=736cf603&scoped=true&"
import script from "./MedicalInfoForm.vue?vue&type=script&lang=js&"
export * from "./MedicalInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalInfoForm.vue?vue&type=style&index=0&id=736cf603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736cf603",
  null
  
)

export default component.exports